import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ArticleCard from '../Lander/ArticleCard';
import { determineCardType } from '../../imgixUtils';
import { isValid, isText, decodeTags } from '../../utils';
import '../Lander/lander-pw.scss';
import { segmentTrackEvent } from '../../utils';

class Recirculation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numArticles: 8,
    };
    this.handleSeeMore = this.handleSeeMore.bind(this);
    this.organizeArticles = this.organizeArticles.bind(this);
    this.renderArticleCards = this.renderArticleCards.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  handleScroll() {
    if (((window.innerHeight + window.scrollY) >= document.body.offsetHeight && this.props.isMobile)) {
      this.handleSeeMore();
    }
  }

  handleSeeMore() {
    segmentTrackEvent('continue', {action: 'more', label: 'more'});
    let { numArticles } = this.state;
    numArticles += 8;

    this.setState({
      numArticles,
    });
  }

  // this method exists in Lander/index.js and a couple of other, similar components. saving for a future refactor (may want to do after the ImageModule refactor as changes to existing logic may be required).
  organizeArticles(numArticles, articles) {
    if (!isValid(articles)) { return null };
    // articles are treated as either big-card or small-card in Recirculation. featured doesn't matter.
    const nextArticles = articles.slice(0, numArticles);

    const articlesWithCardClasses = nextArticles.map((article, i) => {
      return {
        ...article,
        // when i is <= 3 the cardClass becomes "top-card", which we don't want here.
        cardClass: determineCardType(i + 4, false, true, false)
      }
    });

    return articlesWithCardClasses;
  }

  renderArticleCards(articleCards, isReferral) {
    if (!isValid(articleCards)) { return null };
    const { isMobile } = this.props;
    return articleCards.map((articleCard, i) => <ArticleCard key={i} data={articleCard} isMobile={isMobile} shouldDisplaySponsored={false} isReferral={isReferral} isRecirculation={true}/>);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  render() {
    const { articles, recirculation, isMobile, isReferral = false } = this.props;
    let { numArticles } = this.state;
    let recirculationData = null;
    let renderedRecirculation = null;
    let showMoreButton = false;
    if (!isMobile) {
      numArticles *= 2;
    }

    /*
    Recirculation is a child of 4 different components which can be split into 2 groups:
    - Passes data as a recirculation prop (Article, Author). These components are sent a recirculation property in the response JSON from the Express server.
    - Passes data as an articles prop (NotFound, Confirmation). These components manually fetch their Recirculation data.

    We can probably refactor so that all 4 components send the same recirculation prop. This should be considered for a future refactor.
    */

    let isArticleOrAuthor = isValid(recirculation);
    let totalArticles = isArticleOrAuthor ? recirculation.length : isValid(articles.length) ? articles.length : null;

    if (isValid(articles)) {
      recirculationData = this.organizeArticles(numArticles, articles);
    } else if (isValid(recirculation)) {
      recirculationData = this.organizeArticles(numArticles, recirculation);
      showMoreButton = true;
    }

    renderedRecirculation = this.renderArticleCards(recirculationData, isReferral);

    return (
      <Fragment>
        <div className="article-cards">
          {renderedRecirculation}
        </div>
        
        {!isMobile && showMoreButton && isArticleOrAuthor && renderedRecirculation.length < totalArticles &&
          <div className='see-more-button' onClick={this.handleSeeMore}>See More</div>
        }
      </Fragment>
    );
  }
}

Recirculation.propTypes = {
  recirculation: PropTypes.array,
  articles: PropTypes.array,
  isMobile: PropTypes.bool,
};

export default Recirculation;
